import Swiper from 'swiper';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

const wrapper = document.querySelector('.js-promo-slider-wrapper');
const container = document.querySelector('.promo-slider');

export const mainPromoSlider = () => {
	if (!container) return;

	addPromoSlideIds(container);

	new Swiper(container, {
		modules: [Autoplay, Pagination],
		slidesPerView: 1,
		allowTouchMove: true,
		grabCursor: true,
		spaceBetween: 20,
		loop: true,
		speed: 400,
		autoplay: {
			delay: 3000,
		},
		pagination: {
			el: container.querySelector('.swiper-pagination'),
			clickable: true,
		},
		on: {
			init(swiper) {
				setupBackgrounds(swiper);
				updateBackground(swiper);
			},
			slideChange(swiper) {
				updateBackground(swiper);
			},
		},
	});
};

function addPromoSlideIds(container) {
	const slides = container.querySelectorAll('.swiper-slide');

	slides.forEach((slide, index) => {
		slide.dataset.promoSlideId = `promo-slide-${index}`;
	});
}

function setupBackgrounds(swiper) {
	swiper.slides.forEach((slide) => {
		const promoSlideId = slide.dataset.promoSlideId;
		const type = slide.dataset.slideType || 'default';

		if (type === 'default') {
			if (wrapper.querySelector('.promo-slider-wrapper__bg--type--default')) return;

			const bgEl = document.createElement('div');
			bgEl.className = 'promo-slider-wrapper__bg promo-slider-wrapper__bg--type--default';

			wrapper.prepend(bgEl);
			return;
		}

		if (!promoSlideId) return;

		const exists = wrapper.querySelector(
			`.promo-slider-wrapper__bg--type--${type}[data-promo-slide-id="${promoSlideId}"]`,
		);

		if (exists) return;

		const bgEl = document.createElement('div');
		bgEl.className = `promo-slider-wrapper__bg promo-slider-wrapper__bg--type--${type}`;
		bgEl.dataset.promoSlideId = promoSlideId;

		const bgColor = slide.dataset.customSlideBgColor;
		if (bgColor) {
			const normalized = bgColor.startsWith('#') ? bgColor : `#${bgColor}`;
			bgEl.style.setProperty('--custom-slide-bg-color', normalized);
		}
		bgEl.style.setProperty('--custom-slide-bg-image', slide.dataset.customSlideBgImage || '');
		bgEl.style.setProperty(
			'--custom-slide-bg-desktop-image',
			slide.dataset.customSlideBgDesktopImage || '',
		);

		wrapper.prepend(bgEl);
	});
}

function updateBackground(swiper) {
	const slide = swiper.slides[swiper.activeIndex];
	if (!slide) return;

	const promoSlideId = slide.dataset.promoSlideId;
	const type = slide.dataset.slideType || 'default';

	wrapper.querySelectorAll('.promo-slider-wrapper__bg').forEach((bg) => {
		let isVisible = false;

		if (type === 'default') {
			isVisible = bg.classList.contains('promo-slider-wrapper__bg--type--default');
		} else {
			const isSameType = bg.classList.contains(`promo-slider-wrapper__bg--type--${type}`);
			const isSameId = bg.dataset.promoSlideId === promoSlideId;
			isVisible = isSameType && isSameId;
		}

		bg.classList.toggle('is-visible', isVisible);
	});
}
